function escapeHtml(input: string): string {
  return input
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

export function markdownToHtml(markdown: string): string {
  if (!markdown) return "";

  // Normalize line endings
  let text = markdown.replace(/\r\n/g, "\n");

  // Handle fenced code blocks first and store placeholders
  const codeBlocks: string[] = [];
  text = text.replace(/```([\s\S]*?)```/g, (_, code) => {
    const index = codeBlocks.push(`<pre class=\"hljs\"><code>${escapeHtml(code.trim())}</code></pre>`) - 1;
    return `@@CODE_BLOCK_${index}@@`;
  });

  // Headings # to ######
  text = text.replace(/^######\s+(.*)$/gm, '<h6>$1</h6>');
  text = text.replace(/^#####\s+(.*)$/gm, '<h5>$1</h5>');
  text = text.replace(/^####\s+(.*)$/gm, '<h4>$1</h4>');
  text = text.replace(/^###\s+(.*)$/gm, '<h3>$1</h3>');
  text = text.replace(/^##\s+(.*)$/gm, '<h2>$1</h2>');
  text = text.replace(/^#\s+(.*)$/gm, '<h1>$1</h1>');

  // Bold **text** and italics _text_
  text = text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
  text = text.replace(/_(.*?)_/g, '<em>$1</em>');

  // Links [label](url)
  text = text.replace(/\[(.*?)\]\((.*?)\)/g, '<a href="$2" target="_blank" rel="noreferrer">$1</a>');

  // Unordered lists
  text = text.replace(/^(?:\s*[-*]\s+.*(?:\n|$))+?/gm, (block) => {
    const items = block
      .trim()
      .split(/\n/)
      .map((line) => line.replace(/^\s*[-*]\s+/, ''))
      .map((content) => `<li>${content}</li>`) // content may include HTML from prior replacements
      .join('');
    return `<ul>${items}</ul>`;
  });

  // Paragraphs: split on double newlines, wrap plain chunks
  text = text
    .split(/\n{2,}/)
    .map((chunk) => {
      const trimmed = chunk.trim();
      if (!trimmed) return '';
      if (/^<h[1-6]>|^<ul>|^<pre|^<blockquote>/.test(trimmed)) return trimmed;
      return `<p>${trimmed.replace(/\n/g, '<br/>')}</p>`;
    })
    .join('\n');

  // Restore code blocks
  text = text.replace(/@@CODE_BLOCK_(\d+)@@/g, (_, i) => codeBlocks[Number(i)] || '');

  return text;
}




